<template>
  <div class="layout">
    <Header />
    <main>
      <!-- Slot hier ist korrekt -->
      <slot />
    </main>
    <footer>
      <slot name="footer">Default Footer</slot>
    </footer>
  </div>
</template>